const buttonStyle = {
  "&:active": {
    opacity: "0.8",
    outline: "none",
    boxShadow: "0 0 0 3px rgba(21, 156, 228, 0.4)",
  },
  "&:focus": {
    outline: "none",
    boxShadow: "0 0 0 3px rgba(21, 156, 228, 0.4)",
  },
  fontSize: 1,
  fontWeight: 500,
  lineHeight: "1.2",
  mx: "auto",
  outline: "none",
  position: "relative",
  px: 3,
  py: 2,
  transition: "150ms ease-in-out opacity",
};

export { buttonStyle };
